module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/campo-select2/campo-select2.component.css
// module id = ./src/app/shared/componentes/campo-select2/campo-select2.component.css
// module chunks = main